var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelRoundGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDD1D4",
    fillRule: "evenodd",
    d: "M12 1c6.065 0 11 4.935 11 11s-4.935 11-11 11C5.934 23 1 18.065 1 12S5.934 1 12 1zm0 1.443C6.73 2.443 2.443 6.73 2.443 12c0 5.27 4.287 9.557 9.557 9.557 5.27 0 9.557-4.287 9.557-9.557 0-5.27-4.287-9.557-9.557-9.557zm4.371 8.836a.721.721 0 0 1 0 1.442H7.63a.721.721 0 0 1 0-1.442z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelRoundGray);
export default __webpack_public_path__ + "static/media/del_round_gray.635f07373db69598c77f4f8dac7e0792.svg";
export { ForwardRef as ReactComponent };